module.exports = __webpack_public_path__ + "graphics/04.ckh.e6eb4c5af24c1b4f4d367eb920adb0d4.png";